import React, { CSSProperties } from "react";
import bg from "../assets/checkin/bg.jpg";
import footer from "../assets/checkin/footer.png";
import button from "../assets/checkin/button.png";

// Toạ độ theo design UI CHECK IN (khung 780x1550, ảnh xuất PNG trong Design/UI CHECK IN)
export const DESIGN_W = 780;
export const DESIGN_H = 1550;

// px design → độ dài CSS theo bề rộng khung (--w)
export const u = (px: number) => `calc(var(--w) * ${px} / ${DESIGN_W})`;

// Ảnh cắt từ design đặt đúng toạ độ (x, y) và bề rộng w theo px design
export const Piece = ({
  src,
  x,
  y,
  w,
  alt = "",
}: {
  src: string;
  x: number;
  y: number;
  w: number;
  alt?: string;
}) => (
  <img
    src={src}
    alt={alt}
    draggable={false}
    className="absolute pointer-events-none select-none"
    style={{
      left: `${(x / DESIGN_W) * 100}%`,
      top: `${(y / DESIGN_H) * 100}%`,
      width: `${(w / DESIGN_W) * 100}%`,
    }}
  />
);

// Dòng chữ căn giữa; baseline = toạ độ y đường chân chữ trong design, size = cỡ chữ px design
export const Line = ({
  baseline,
  size,
  weight = 500,
  className = "",
  style,
  children,
}: {
  baseline: number;
  size: number;
  weight?: number;
  className?: string;
  style?: CSSProperties;
  children: React.ReactNode;
}) => (
  <div
    className={`absolute left-0 w-full text-center whitespace-nowrap ${className}`}
    style={{
      top: u(baseline - size * 0.8),
      fontSize: u(size),
      lineHeight: 1,
      fontWeight: weight,
      letterSpacing: "0.02em",
      ...style,
    }}
  >
    {children}
  </div>
);

// Nút theo style "Quay về" của design (nền nút cắt từ PSD, chữ vẽ bằng CSS); y = đỉnh ảnh nút
export const DesignButton = ({
  label,
  y = 832,
  onClick,
  disabled = false,
}: {
  label: string;
  y?: number;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="absolute bg-transparent border-0 p-0 cursor-pointer active:scale-95 transition-transform disabled:opacity-60"
    style={{
      left: `${(196 / DESIGN_W) * 100}%`,
      top: `${(y / DESIGN_H) * 100}%`,
      width: `${(388 / DESIGN_W) * 100}%`,
      height: `${(122 / DESIGN_H) * 100}%`,
      backgroundImage: `url(${button})`,
      backgroundSize: "100% 100%",
      WebkitTapHighlightColor: "transparent",
    }}
  >
    <span
      className="checkin-btn-text block text-white font-bold"
      style={{ fontSize: u(41.7), lineHeight: 1, letterSpacing: "0.02em" }}
    >
      {label}
    </span>
  </button>
);

export default function CheckinStage({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <div className="checkin-page" style={{ backgroundImage: `url(${bg})` }}>
      <img src={footer} alt="" draggable={false} className="checkin-footer" />
      <div className="checkin-stage">{children}</div>
    </div>
  );
}
